import React from 'react';
import type { StyledProps } from '@compiled/react';
import { styled } from '@compiled/react';

import {
	cssMap,
	cx,
	type StrictXCSSProp,
	type XCSSAllProperties,
	type XCSSAllPseudos,
} from '@atlaskit/css';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import Box from '@atlaskit/primitives/box';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ContentTypesHeaderContainer: React.ComponentType<
	{
		isFloating?: boolean;
		hasPointerEvents?: boolean;
	} & React.ClassAttributes<HTMLDivElement> &
		React.HTMLAttributes<HTMLDivElement> &
		StyledProps
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
> = styled.div<{
	isFloating?: boolean;
	hasPointerEvents?: boolean;
}>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	position: (props) => {
		return props.isFloating ? 'absolute' : 'relative';
	},
	background: 'transparent',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	pointerEvents: (props) => {
		return props.hasPointerEvents ? 'auto' : 'none';
	},
	width: '100%',
	display: 'grid',
});

const styles = cssMap({
	base: {
		pointerEvents: 'auto',
		backgroundColor: token('elevation.surface'),
		borderRadius: token('radius.small'),
		paddingInline: token('space.100'),
		paddingBlockEnd: token('space.050'),
		display: 'flex',
		flexWrap: 'nowrap',
		paddingBlockStart: token('space.050'),
		height: '100%',
	},
	// Utilized only when the content header is pinned and during the viewing of public whiteboards
	alignCenter: {
		alignSelf: 'center',
	},
});

type TitleAndBreadcrumbsWrapperXcss = StrictXCSSProp<XCSSAllProperties, XCSSAllPseudos>;

export const TitleAndBreadcrumbsWrapper = ({
	isContentHeaderPinned = false,
	xcss,
	children,
}: {
	isContentHeaderPinned?: boolean;
	xcss?: TitleAndBreadcrumbsWrapperXcss;
	children: React.ReactNode;
}): React.JSX.Element => {
	return (
		<Box xcss={cx(styles.base, isContentHeaderPinned && styles.alignCenter, xcss)}>{children}</Box>
	);
};
